<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
html,
body,
#app {
  word-break: break-all;
  width: 100%;
  height: 100%;
  background: #ffffff;
  color: #333333;
  overflow: hidden;
  margin: 0;
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  ul,
  li,
  ol {
    list-style: none;
    padding: 0;
  }

  .ant-cascader-menu-item {
    padding: 5px 12px !important;
  }

  .ant-table-tbody .ant-btn {
    margin: 0 2px;
  }
  .operation-text {
    cursor: pointer;
  }
  .he-control-bar {
    width: 300px !important;
  }
  .he-close-icon {
    color: #000 !important;
  }
  .ant-select-dropdown-menu-item {
    padding: 5px 12px;
  }
  .ant-cascader-menu {
    width: 194px !important;
  }
  .table_box {
    width: 100%;
    height: auto;
    color: #333;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 2px 10px 0px rgba(18, 15, 35, 0.04);
    padding: 24px 24px 32px;
  }
  .filter_box {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .ant-form {
      margin-right: 20px;
      position: relative;
    }
  }
  .ant-table-fixed-left,
  .ant-table-fixed-right {
    bottom: 0;
  }

  .ant-table-hide-scrollbar::-webkit-scrollbar {
    min-width: 6px !important;
  }

  .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    &::-webkit-scrollbar {
      width: 6px !important;
    }
  }

  .ant-table-fixed-header
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgb(149, 149, 149);
    }

    &::-webkit-scrollbar-track  {
      /*box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      border-radius: 10px;
      background: rgba(149, 149, 149, 0);
    }
  }

  .ant-table-body {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgb(149, 149, 149);
    }

    &::-webkit-scrollbar-track  {
      /*box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      border-radius: 10px;
      background: rgba(149, 149, 149, 0);
    }
  }

  .ant-table-body-inner {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgb(149, 149, 149);
    }

    &::-webkit-scrollbar-track  {
      /*box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      border-radius: 10px;
      background: rgba(149, 149, 149, 0);
    }
  }
  ::selection {
    background: #00a0e9;
    color: #ffffff;
  }
}
</style>
